module.exports = __webpack_public_path__ + "static/media/YM34_4.edd98278.jpg";